module.exports = __webpack_public_path__ + "img/event2025_0318_2.47a56e41.jpg";